import { AppElement, AppFC } from '../../../interfaces';

export const AddIcon: AppFC = (props): AppElement => (
  <svg {...props} xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
    <path d="M12.1431 6.14314L7.85742 6.14314V1.85742L6.14314 1.85742V6.14314H1.85742L1.85742 7.85742H6.14314L6.14314 12.1431H7.85742L7.85742 7.85742L12.1431 7.85742V6.14314Z" fill="white" />
  </svg>
);
